module.exports = __webpack_public_path__ + "static/media/triangle-r.090ec7e5.svg";